module.exports = __webpack_public_path__ + "static/img/sydney1.70fb7a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sydney1.jpg
// module id = 9K6B
// module chunks = 1